import { animate, spring } from "motion";

export default {
  init: () => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }

    const shapes = document.querySelectorAll(".parallax-shape");

    if (!shapes.length) {
      return;
    }

    shapes.forEach((shape) => {
      animate(shape, { y: ["50%", "0%"], opacity: [0, 1] }, { easing: spring({ stiffness: 50, damping: 20 }) });
    });

    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop;

      shapes.forEach((shape) => {
        const factor = shape.dataset.distance ?? 0.1;
        const translateY = scrollTop * parseFloat(factor) * -1;

        animate(shape, { y: translateY }, { easing: spring({ stiffness: 50, damping: 20 }) });
      });
    };

    let ticking = false;

    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    handleScroll();
  },
};
